import { publicConfig } from '@public-config';

import type { File } from 'models';

export type ImageKitTransformOptions = {
    width?: number;
    height?: number;
    disableCrop?: boolean;
    dpr?: number;
    blur?: number;
    page?: number;
};

export const ImageKitHelpers = {
    buildImageKitTransform: (opts: ImageKitTransformOptions = {}): string => {
        const { width, height, disableCrop, dpr = 2, blur, page } = opts;

        return [
            width ? `w-${width}` : '',
            height ? `h-${height}` : '',
            `dpr-${dpr}`,
            disableCrop && 'cm-pad_resize',
            blur && `bl-${blur}`,
            page && `pg-${page}`,
        ]
            .filter(Boolean)
            .join(',');
    },

    buildTransform: (transform?: string): string => {
        return transform && transform.length > 0 ? `/tr:${transform}` : '';
    },

    buildSrc: (path: string, transform: string, fallback: string): string => {
        const base = publicConfig.imageKitPublicKey;

        if (!base) {
            return fallback;
        }

        const tr = ImageKitHelpers.buildTransform(transform);

        return `${base}${tr}/${path}`;
    },

    getSrcFromFile: (file: File, opts: ImageKitTransformOptions = {}): string => {
        const width = file.width;
        const height = file.height;

        const transform = ImageKitHelpers.buildImageKitTransform({ width, height, ...opts });

        return ImageKitHelpers.buildSrc(`${file.prefix}/${file.filename}`, transform, file.url);
    },

    getDocumentThumbnailSrc: (file: File, opts: ImageKitTransformOptions = {}): string | null => {
        const base = publicConfig.imageKitPublicKey;

        if (!base) {
            return null;
        }

        const transform = ImageKitHelpers.buildTransform(ImageKitHelpers.buildImageKitTransform(opts));

        return `${base}${transform}/${file.prefix}/${file.filename}/ik-thumbnail.jpg`;
    },

    getSrcFromUrl: (url: string, opts: ImageKitTransformOptions = {}): string => {
        const transform = ImageKitHelpers.buildImageKitTransform(opts);

        return ImageKitHelpers.buildSrc(url, transform, url);
    },
};
